import { render, staticRenderFns } from "./UploadMediaForm.vue?vue&type=template&id=16229985"
import script from "./UploadMediaForm.vue?vue&type=script&lang=js"
export * from "./UploadMediaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports